// extracted by mini-css-extract-plugin
export default {"wrapper":"StudentLessonMedia_wrapper__Lcpbz","hostOnly":"StudentLessonMedia_hostOnly__J9FKx","peer":"StudentLessonMedia_peer__GZ0KT","host":"StudentLessonMedia_host__XWwXq"};